const state = {
  currentToast: undefined,
  isGlobalToastVisible: false
};

export default state;



// WEBPACK FOOTER //
// ./src/store/modules/toasts/state.js